<template>
  <MainMobile>
    <template #before>
      <AppAlerts />
      <AppAnalyticsProgressBar />
    </template>
    <template #footer>
      <MainMobileRepositories />
      <MainMobileTree />
      <MainMobileAddAsset />
    </template>
    <template #footer-after="{ isEmptyApp }">
      <MainMobileMore :is-empty-app class="main-mobile-footer__item" />
    </template>
  </MainMobile>
</template>

<script setup lang="ts">
import MainMobile from './Mobile/Mobile.vue'
import { AppAlerts, AppAnalyticsProgressBar } from '@app'

import MainMobileRepositories from './MainMobileRepositories.vue'
import MainMobileTree from './MainMobileTree.vue'
import MainMobileAddAsset from './MainMobileAddAsset.vue'
import MainMobileMore from './Mobile/More/More.vue'

</script>
